"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var whitelabelTheme = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _32;
    var MAX_L = _a.MAX_L, MAX_S = _a.MAX_S, MIN_S = _a.MIN_S, MAX_M = _a.MAX_M, MIN_M = _a.MIN_M, MAX_XS = _a.MAX_XS, cssPrefix = _a.cssPrefix;
    return ({
        palette: {
            type: 'light',
            primary: {
                dark: "#333",
                main: "#666",
                light: "#999",
                contrastText: "#DDD"
            },
            secondary: {
                main: "#2792F3",
            }
        },
        overrides: {
            MuiCssBaseline: {
                "@global": (_b = {
                        "body": {
                            backgroundColor: '#fff'
                        },
                        "#nprogress .peg": {
                            boxShadow: "0 0 5px #2792F3, 0 0 5px #2792F3",
                            backgroundColor: "#2792F3"
                        }
                    },
                    _b[".search-index ." + cssPrefix + "_hero_title"] = {
                        display: "flex"
                    },
                    _b),
            },
            MuiInputBase: {
                input: {
                    '&:-webkit-autofill': {
                        WebkitBoxShadow: 'inset 0 0 0px 9999px #fff',
                        WebkitTextFillColor: '#333',
                    },
                },
            }
        },
        layout: (_c = {},
            _c["&.section-index , &." + cssPrefix + "_error-page_root"] = (_d = {},
                _d["& ." + cssPrefix + "-portal_hero_nav-popover"] = {
                    display: "none"
                },
                _d["& ." + cssPrefix + "-portal_hero_title"] = {
                    display: "flex"
                },
                _d),
            _c["&.index-root"] = (_e = {},
                _e["& ." + cssPrefix + "_hero_nav-popover"] = {
                    display: "none"
                },
                _e),
            _c["&.section-index"] = (_f = {},
                _f["& ." + cssPrefix + "_hero_title"] = {
                    display: "none"
                },
                _f["& ." + cssPrefix + "_version-selector_button"] = {
                    border: "none"
                },
                _f),
            _c["&.content-index, &.section-index"] = (_g = {},
                _g["& ." + cssPrefix + "_site-groups_root"] = {
                    marginTop: "0"
                },
                _g["& ." + cssPrefix + "_hero_root"] = {
                    display: "block"
                },
                _g),
            _c["&.search"] = (_h = {},
                _h["& ." + cssPrefix + "_hero_root"] = {
                    display: "none"
                },
                _h),
            _c["& ." + cssPrefix + "_site-section-tiles_section-icon, & ." + cssPrefix + "_content_section-icon"] = {
                display: 'none'
            },
            _c),
        layoutHeaderTitle: (_j = {
                display: "flex"
            },
            _j[MIN_S] = {
                flex: "auto",
                width: "100%",
                "& i18n-message": {
                    display: "none"
                },
            },
            _j[MAX_S] = {
                display: "none"
            },
            _j),
        siteSectionTiles: {},
        siteSectionTilesIcon: {
            display: "none"
        },
        siteSectionTextWrapper: {
            flex: 1
        },
        siteSectionTilesLinks: (_k = {
                display: "grid",
                gridAutoRows: "minmax(300px, max-content)",
                gridGap: "1rem",
                padding: "2rem"
            },
            _k[MIN_M] = {
                padding: "2rem 1.5rem",
                gridTemplateColumns: "repeat(3, 1fr)",
            },
            _k[MAX_M] = {
                margin: "0 1rem",
                gridTemplateColumns: "repeat(2, 1fr)",
            },
            _k[MAX_S] = {
                gridTemplateColumns: "repeat(1, 1fr)",
                padding: "2rem  1rem",
            },
            _k.marginTop = "0",
            _k.justifyContent = "center",
            _k.maxWidth = "900px",
            _k.margin = "0 auto",
            _k["& a"] = (_l = {
                    borderRadius: "5px",
                    gridGap: "0.25rem",
                    alignItems: "center",
                    alignContent: "center",
                    overflowWrap: "break-word",
                    textDecoration: "none"
                },
                _l[MAX_L] = {
                    padding: "1rem",
                    gridGap: "0.125rem",
                },
                _l[MAX_M] = {
                    padding: "0.5rem",
                },
                _l),
            _k),
        errorPageSiteSectionLinks: (_m = {
                display: "grid",
                gridAutoRows: "minmax(300px, max-content)",
                gridGap: "1rem",
                padding: "2rem"
            },
            _m[MIN_M] = {
                padding: "2rem 1.5rem",
                gridTemplateColumns: "repeat(3, 1fr)",
                margin: "0 auto"
            },
            _m[MAX_M] = {
                margin: "0 1rem",
                padding: "2rem 1rem",
                gridTemplateColumns: "repeat(2, 1fr)",
            },
            _m[MAX_S] = {
                gridTemplateColumns: "repeat(1, 1fr)",
            },
            _m["& a"] = (_o = {
                    gridGap: "0.25rem",
                    alignItems: "center",
                    alignContent: "center",
                    overflowWrap: "break-word",
                    textDecoration: "none",
                    display: "flex",
                    flexBasis: "calc(20% - 2rem)",
                    flexDirection: "column",
                    padding: "2rem",
                    borderRadius: "5px",
                    margin: "0",
                    justifyContent: "flex-start",
                    transition: "all 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
                    boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.15)",
                    backgroundColor: "transparent"
                },
                _o[MAX_L] = {
                    padding: "1rem",
                    gridGap: "0.125rem",
                    flexBasis: "calc(25% - 2rem)",
                },
                _o[MAX_M] = {
                    width: "300px",
                    height: "300px",
                    padding: "1rem",
                    margin: "0 auto"
                },
                _o),
            _m.marginTop = "0",
            _m.justifyContent = "center",
            _m.maxWidth = "900px",
            _m.margin = "0 auto",
            _m),
        indexSiteSectionContainer: (_p = {
                display: "grid",
                gridAutoRows: "minmax(300px, max-content)",
                gridGap: "1rem",
                padding: "2rem"
            },
            _p[MIN_M] = {
                padding: "2rem 1.5rem",
                gridTemplateColumns: "repeat(3, 1fr)",
                margin: "0 auto"
            },
            _p[MAX_M] = {
                margin: "0 1rem",
                padding: "2rem 1rem",
                gridTemplateColumns: "repeat(2, 1fr)",
            },
            _p[MAX_S] = {
                gridTemplateColumns: "repeat(1, 1fr)",
            },
            _p["& a"] = (_q = {
                    gridGap: "0.25rem",
                    alignItems: "center",
                    alignContent: "center",
                    overflowWrap: "break-word",
                    textDecoration: "none"
                },
                _q[MAX_L] = {
                    padding: "1rem",
                    gridGap: "0.125rem",
                },
                _q[MAX_M] = {
                    padding: "1rem",
                },
                _q),
            _p.marginTop = "0",
            _p.justifyContent = "center",
            _p.maxWidth = "900px",
            _p.margin = "0 auto",
            _p),
        appBar: {
            alignContent: "center",
            height: "5rem",
            width: "100%",
        },
        hero: {
            position: "relative",
            height: "auto",
            backgroundPosition: "center",
            backgroundSize: "cover",
            marginBottom: "0",
            opacity: 1,
            alignItems: "center",
            alignContent: "center",
            "& i18n-message": {
                flex: 1
            },
            "&.index-root, &.section-index, &.content-index, &.search-index, &.error-index": {
                backgroundImage: "url(https://assets.portal.heretto.com/themes/whitelabel/Geometric-Background.webp)",
            },
        },
        heroSearchWrapper: (_r = {
                height: "2.25rem",
                width: "30rem",
                margin: "0 auto"
            },
            _r[MAX_S] = {
                display: "none"
            },
            _r),
        heroSearchBox: {
            icon: 'search',
            fontSize: "14px",
            borderRadius: "1.5rem",
            backgroundColor: "#FFF",
            "& .material-icons": {
                color: "#232B40",
                fontSize: "1.25rem",
                marginTop: "0.25rem"
            }
        },
        siteGroups: {
            paddingTop: "0",
            "& > *": (_s = {
                    maxWidth: "1440px",
                    margin: "0 auto",
                    padding: "0 1rem"
                },
                _s[MAX_M] = {
                    padding: "0 1.5rem",
                },
                _s[MAX_S] = {
                    padding: "0 1rem",
                },
                _s)
        },
        layoutContainer: {},
        heroTitle: (_t = {
                color: "#fff",
                lineHeight: "4rem",
                marginBottom: "1rem"
            },
            _t[MAX_M] = {
                fontSize: "3rem",
                lineHeight: "3rem",
            },
            _t[MAX_S] = {
                fontSize: "2rem",
                lineHeight: "2rem",
            },
            _t.margin = "0",
            _t.fontWeight = "normal",
            _t.display = "flex",
            _t.justifyContent = "center",
            _t.component = 'h1',
            _t.fontSize = "3rem",
            _t),
        heroTitleWrapper: {
            fontSize: "1.75em",
            flex: 1,
            display: "flex",
            flexDirection: "column",
            textAlign: 'center',
            opacity: 1,
            justifyContent: "center",
            maxWidth: "1440px",
            margin: "0 auto",
            color: "#FFFFFF",
            padding: "2rem 1rem 3rem 1rem",
            height: "300px"
        },
        appBarSearchIcon: (_u = {
                name: 'search',
                close: 'close',
                color: "#fff"
            },
            _u[MAX_S] = {
                color: "#545454",
                marginRight: "0",
                marginLeft: "1rem"
            },
            _u["& .material-icons"] = {},
            _u[MIN_S] = {
                display: "none",
            },
            _u),
        appBarSearchCollapse: {},
        searchBox: {
            height: "100%",
            color: "#4f4e4c",
            boxShadow: "0px 6px 6px -3px rgba(0,0,0,0.2), 0px 10px 14px 1px rgba(0,0,0,0.14), 0px 4px 18px 3px rgba(0,0,0,0.12)",
        },
        heroSubTitle: (_v = {
                color: "#fff",
                display: "inline-block",
                textAlign: "center",
                fontSize: "1.5rem",
                lineHeight: "1.75rem",
                width: "55%",
                alignSelf: "center"
            },
            _v[MAX_M] = {
                fontSize: "1.25rem",
                lineHeight: "1.5rem"
            },
            _v[MAX_S] = {
                fontSize: "1rem",
                lineHeight: "1.25rem"
            },
            _v),
        appBarHome: {},
        appBarImage: (_w = {
                imageSrc: "https://assets.portal.heretto.com/themes/whitelabel/Stock-Logo.webp",
                height: "3rem"
            },
            _w[MAX_M] = {
                width: "auto",
                height: "auto",
                maxHeight: "2.5rem"
            },
            _w[MAX_S] = {
                maxHeight: "2rem"
            },
            _w),
        appBarDrawerHome: (_x = {},
            _x[MAX_S] = {
                justifyContent: "left",
            },
            _x.paddingLeft = "1rem",
            _x),
        appBarDrawerImage: {
            imageSrc: "https://assets.portal.heretto.com/media/easyDITA-logo.webp"
        },
        appBarDrawerHomeImage: {},
        portalTabsProps: {
            indicatorColor: "secondary",
            textColor: "primary",
            TabIndicatorProps: {
                style: {
                    height: "3px"
                }
            },
            scrollButtons: "on",
            variant: "scrollable"
        },
        portalTabs: (_y = {
                display: "flex",
                backgroundColor: "#fff",
                borderBottom: "1px solid #707070",
                justifyContent: "center",
                minHeight: "auto",
                height: "3rem"
            },
            _y[MAX_M] = {
                display: "none"
            },
            _y["& .mui-tabs_scroller"] = {
                flex: "none"
            },
            _y),
        appBarNavPopoverWrapper: (_z = {},
            _z["& ." + cssPrefix + "_portal-popover_trigger"] = {},
            _z[MAX_S] = {
                display: "none",
            },
            _z),
        portalTabsItem: (_0 = {
                fontSize: "1rem",
                lineHeight: "1rem",
                margin: "0 1rem",
                flexGrow: "0"
            },
            _0[MAX_L] = {
                fontSize: "0.75rem",
                margin: "0",
            },
            _0),
        appBarDrawerButton: {},
        appBarToolbar: {
            maxWidth: "1440px",
            margin: "0 auto",
            padding: "0 1rem"
        },
        footerLanguageSelectWrapper: {},
        footer: (_1 = {
                color: "#fff",
                backgroundColor: "rgb(35, 35, 35)",
                background: "initial",
                width: "100%"
            },
            _1[MIN_M] = {
                display: "block",
                position: "relative"
            },
            _1[MAX_M] = {
                display: "block"
            },
            _1),
        footerContainer: {
            gridTemplateColumns: "1fr"
        },
        footerRelatedResourcesDescription: {},
        footerRelatedResources: {
            gridTemplateColumns: "1fr 1fr"
        },
        footerLinkContainer: {
            gridTemplateColumns: "100%"
        },
        footerLinkItemText: {},
        footerLinkHeader: {
            marginBottom: "1rem"
        },
        footerRelatedResourcesHeader: {
            marginBottom: "1rem"
        },
        footerRelatedResourcesText: {},
        footerSiteNavWrapper: {
            display: "none"
        },
        footerLinkWrapper: {},
        siteSectionHref: {
            padding: "0",
            flexDirection: "row",
            color: "rgb(69, 75, 82)",
            borderRadius: "10px",
        },
        siteSectionText: (_2 = {
                color: "#707070",
                fontSize: "1.5rem",
                marginTop: "0"
            },
            _2[MAX_L] = {
                fontSize: "1.25rem"
            },
            _2[MAX_S] = {
                fontWeight: "normal",
                fontSize: "1rem"
            },
            _2),
        errorPageSiteSectionTitle: {
            color: "#707070",
            fontSize: "1.5rem",
            marginTop: "0",
            fontWeight: "bold",
        },
        errorPageNextStepsMessage: {
            display: "none",
        },
        indexSiteSectionTitle: {
            color: "#707070",
            fontSize: "1.5rem",
            fontWeight: "bold",
            marginTop: "0",
        },
        siteSectionDescription: (_3 = {
                color: "#707070",
                textAlign: "center"
            },
            _3[MAX_L] = {
                fontSize: "0.625rem"
            },
            _3[MAX_S] = {
                fontSize: "0.5rem"
            },
            _3.fontSize = "1rem",
            _3),
        indexSiteSectionDescription: (_4 = {
                color: "#707070",
                textAlign: "center",
                fontSize: "1rem"
            },
            _4[MAX_L] = {
                fontSize: "0.625rem"
            },
            _4[MAX_S] = {
                fontSize: "0.5rem"
            },
            _4),
        contentPageSiteSectionTitle: {
            color: "#2E2E2E",
            fontSize: "1.125rem",
        },
        indexSiteSectionHeader: {
            display: "none"
        },
        indexSiteSectionLink: (_5 = {
                display: "flex",
                flexBasis: "calc(20% - 2rem)",
                flexDirection: "column",
                alignItems: "center",
                alignContent: "start",
                overflowWrap: "break-word"
            },
            _5[MAX_L] = {
                flexBasis: "calc(25% - 2rem)",
            },
            _5.textDecoration = "none",
            _5.padding = "2rem",
            _5.borderRadius = "5px",
            _5.margin = "0",
            _5.justifyContent = "flex-start",
            _5.transition = "all 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
            _5.boxShadow = "0px 4px 20px rgba(0, 0, 0, 0.15)",
            _5.backgroundColor = "transparent",
            _5[MAX_M] = {
                width: "300px",
                height: "300px",
                margin: "0 auto"
            },
            _5),
        siteSectionTilesContainer: (_6 = {
                margin: "1rem 2rem",
                display: "flex",
                flexDirection: "column"
            },
            _6[MAX_S] = {
                alignItems: "left",
                flexDirection: "column",
                border: "none",
                marginBottom: "0px",
                justifyContent: "space-between"
            },
            _6),
        siteGroupsRelatedResources: {
            display: "none"
        },
        showContentsWrapper: {
            "& .material-icons": {
                color: "#333",
            }
        },
        showContentsTitle: (_7 = {},
            _7[MAX_S] = {
                display: "flex",
                padding: "0 0.5rem",
                marginBottom: "0.5rem",
            },
            _7),
        contentPageContainer: (_8 = {
                padding: '0 2rem',
                gridAutoRows: "minmax(100%, min-content)",
                gridTemplateColumns: "315px auto",
                margin: "0 auto",
                maxWidth: "1440px"
            },
            _8[MAX_M] = {
                padding: "0.5rem 1rem",
            },
            _8[MAX_S] = {
                padding: "0",
            },
            _8),
        relatedLinks: {},
        relatedLinksListItem: {},
        relatedLinksTitle: {},
        relatedLinksListItemHref: {},
        contentPageChunkedSectionsWrapper: (_9 = {
                display: "inherit"
            },
            _9[MAX_M] = {
                padding: "0.5rem",
            },
            _9),
        contentPageToc: {
            height: "85%",
        },
        contentPageTocContainer: {
            "& > *": (_10 = {},
                _10[MIN_M] = {
                    backgroundColor: "transparent"
                },
                _10),
            "& > .mui-paper_root": (_11 = {},
                _11[MIN_M] = {
                    paddingTop: "1rem",
                },
                _11),
        },
        contentPageMainContainer: {
            display: "flex",
        },
        contentPageMainWrapper: (_12 = {},
            _12[MIN_M] = {
                borderLeft: "1px solid #333",
                paddingLeft: "2rem",
                paddingTop: "2rem",
            },
            _12[MAX_S] = {
                padding: "0"
            },
            _12["& render-html"] = (_13 = {
                    paddingRight: "2rem"
                },
                _13[MAX_S] = {
                    paddingRight: "0.5rem",
                },
                _13["& table"] = {
                    width: "100%",
                    textAlign: "left",
                    borderCollapse: "collapse",
                    borderSpacing: "5px",
                    "& thead > tr:last-child": {
                        width: "100%"
                    },
                    "& tbody tr:nth-child(even)": {
                        backgroundColor: "rgba(140,140,140,0.1)"
                    }
                },
                _13["& td"] = {
                    paddingRight: "1rem"
                },
                _13["& thead, tbody > tr"] = {
                    borderWidth: "0",
                    borderStyle: "none",
                    borderBottomWidth: "1px",
                    borderBottomColor: "rgba(0,0,0, 0.3)",
                    borderBottomStyle: "solid",
                    borderCollapse: "separate",
                    borderSpacing: "1rem",
                },
                _13["& tr, td, th"] = {
                    borderColor: "rgba(0,0,0, 0.3)",
                    borderWidth: "1px",
                    borderStyle: "solid",
                    borderCollapse: "separate",
                    borderSpacing: "5px 5px",
                },
                _13["& pre.prettyprint"] = (_14 = {
                        backgroundColor: "rgba(140,140,140,0.1)",
                        padding: "1rem"
                    },
                    _14[MAX_S] = {
                        padding: "0.5rem",
                    },
                    _14),
                _13["& ul"] = {
                    listStyleType: "none",
                    "& > li::before": {
                        content: '"-"'
                    },
                },
                _13["& ul, ol"] = {
                    paddingLeft: '0.5rem',
                    "& > li::before": {
                        display: "inline !important",
                        marginRight: "0.5rem"
                    }
                },
                _13["& ol"] = (_15 = {
                        paddingLeft: "2.5rem"
                    },
                    _15[MAX_S] = {
                        paddingLeft: "1.5rem"
                    },
                    _15),
                _13["& .note"] = (_16 = {
                        padding: "1rem",
                        margin: "1rem"
                    },
                    _16[MAX_S] = {
                        marginTop: "1.5rem"
                    },
                    _16),
                _13["& .note_attention, .note_note"] = {
                    color: "#0381B9",
                    backgroundColor: "rgba(3, 129, 185, 0.14)",
                    "&::before": {
                        backgroundColor: "#0381B9",
                    }
                },
                _13["& .note_caution"] = {
                    color: "#D3AA00",
                    backgroundColor: "rgba(211, 170, 0, 0.14)",
                    "&::before": {
                        backgroundColor: "#D3AA00",
                    }
                },
                _13["& .note_danger"] = {
                    color: "#B90503",
                    backgroundColor: "rgba(185, 5, 3, 0.14)",
                    "&::before": {
                        backgroundColor: "#B90503",
                    }
                },
                _13["& .note_note, .note_attention, .note_caution, .note_danger"] = (_17 = {
                        position: "relative",
                        paddingLeft: "1.75rem"
                    },
                    _17[MAX_S] = {
                        paddingLeft: "1rem",
                        margin: "0",
                    },
                    _17["&::before"] = (_18 = {
                            position: "absolute",
                            color: "inherit",
                            left: "0.5rem",
                            top: "1.25rem",
                            display: "inline-block",
                            height: "1rem",
                            width: "1rem",
                            content: "''"
                        },
                        _18[MAX_S] = {
                            left: "calc(50% - 1rem)",
                            top: "-1rem",
                            height: "2rem",
                            width: "2rem"
                        },
                        _18),
                    _17),
                _13["& .note_note"] = {
                    "&::before": {
                        mask: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' class='MuiSvgIcon-root jss160' focusable='false' viewBox='0 0 24 24' aria-hidden='true' tabindex='-1'%3E%3Cpath d='M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 11c-.55 0-1-.45-1-1V8c0-.55.45-1 1-1s1 .45 1 1v4c0 .55-.45 1-1 1zm1 4h-2v-2h2v2z'%3E%3C/path%3E%3C/svg%3E\")"
                    }
                },
                _13["& .note_attention, .note_caution, .note_danger"] = {
                    "&::before": {
                        mask: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' class='MuiSvgIcon-root jss172' focusable='false' viewBox='0 0 24 24' aria-hidden='true'%3E%3Cpath d='M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z'%3E%3C/path%3E%3C/svg%3E\")"
                    }
                },
                _13),
            _12),
        contentPageHeaderBreadcrumb: {},
        siteSectionBreadcrumb: {
            marginLeft: '0.5rem',
            "& svg": {
                color: "#545454",
            },
            "& p": {
                color: "#545454",
                fontSize: "0.75rem",
            },
        },
        landingHeaderBreadcrumb: {
            marginLeft: '0.5rem',
            "& svg": {
                color: "#545454",
            },
            "& p": {
                color: "#545454",
                fontSize: "0.75rem",
            },
        },
        portalBreadcrumb: {
            separator: "chevron_right",
            margin: "0.0625rem 0.125rem !important"
        },
        portalBreadcrumbIcon: {
            color: '#545454',
            fontSize: "0.875rem"
        },
        contentPageShareButton: (_19 = {},
            _19["& ." + cssPrefix + "_portal-popover_wrapper"] = {
                display: "block"
            },
            _19),
        stepLinkIcon: {
            color: "#545454"
        },
        showContents: {
            "& .material-icons": {}
        },
        showContentsIcon: (_20 = {},
            _20[MIN_S] = {
                width: "auto",
                height: "50px",
            },
            _20[MAX_S] = {
                width: "auto",
                height: "50px",
                display: "block"
            },
            _20[MAX_XS] = {
                width: "30px",
                height: "30px",
            },
            _20),
        contentPageTocHeader: (_21 = {
                height: "3.75rem"
            },
            _21[MIN_M] = {
                display: "none",
            },
            _21),
        showContentsSections: {
            display: "none",
        },
        contentPageSiteSectionIconWrapper: {
            marginTop: "0.5rem",
            marginBottom: "0.25rem",
        },
        portalBreadcrumbHref: {
            color: "#545454",
            "& i18n-message": {
                fontSize: "12px"
            }
        },
        metadataItem: {},
        metadataLastModified: {
            display: "none"
        },
        simpleTree: {
            color: "#545454",
            fontSize: "0.5rem",
            "& .mui-tree-item_label": {
                paddingLeft: "0"
            }
        },
        simpleTreeItem: {
            "& p": {
                paddingLeft: ".25rem",
                fontSize: '0.875rem'
            }
        },
        simpleTreeItemSelected: {
            "& p": {
                backgroundColor: "#2792F3 !important",
                color: "#FFF !important",
                paddingLeft: ".25rem",
                fontSize: '0.875rem'
            }
        },
        appBarSearchBox: (_22 = {
                icon: 'search',
                color: "#4C4C4C",
                fontSize: "14px",
                borderRadius: "1.5rem",
                backgroundColor: "#fff",
                "& .material-icons": {
                    color: "#4C4C4C"
                }
            },
            _22[MIN_S] = {
                transition: "all 0.3s ease-in-out",
                boxShadow: "none",
                "&:focus-within": {
                    boxShadow: "0px 6px 6px -3px rgb(0 0 0 / 20%), 0px 10px 14px 1px rgb(0 0 0 / 14%), 0px 4px 18px 3px rgb(0 0 0 / 12%)"
                }
            },
            _22),
        indexSiteSectionIcon: (_23 = {
                height: "70px",
                width: "auto",
                display: "flex",
                alignSelf: "center",
                justifySelf: "center",
                marginBottom: "1rem",
                "&> img": {
                    height: "100%",
                }
            },
            _23[MAX_S] = {
                marginTop: "1rem",
            },
            _23[MAX_XS] = {
                marginTop: "0.5rem",
                height: "70px",
                width: "auto",
            },
            _23),
        errorPageSiteSectionIcon: (_24 = {
                height: "70px",
                width: "auto",
                display: "flex",
                alignSelf: "center",
                justifySelf: "center",
                marginBottom: "1rem",
                "&> img": {
                    height: "100%",
                }
            },
            _24[MAX_S] = {
                marginTop: "1rem",
            },
            _24[MAX_XS] = {
                marginTop: "0.5rem",
                height: "70px",
                width: "auto",
            },
            _24),
        navTree: {
            iconCollapse: "close",
            iconExpand: "add"
        },
        navTreeItemSelected: {
            borderLeft: "none",
            color: "#FFF",
            backgroundColor: "#2792F3 !important",
        },
        navTreeItemExpanded: {},
        navTreeIcon: {
            fontSize: "1rem"
        },
        navTreeItemGroup: {
            marginLeft: "0"
        },
        navTreeItemHover: {
            backgroundColor: "#eee"
        },
        navTreeItemLabel: {
            paddingLeft: "0",
            padding: "0.25rem",
            marginLeft: "0",
        },
        navTreeItem: {
            flexDirection: "row-reverse",
        },
        contentPageChunkedSectionsTitle: (_25 = {},
            _25[MIN_M] = {
                fontWeight: "bold",
                marginLeft: "1.5rem"
            },
            _25),
        appBarSearchBoxIcon: {
            height: '18px',
            transform: "translate(14px, -2px)",
            color: "rgba(0,0,0,0.7)"
        },
        appBarSearchWrapper: (_26 = {},
            _26[MIN_S] = {
                display: "none",
            },
            _26),
        siteSectionIconTitleWrapper: {
            margin: "0",
        },
        siteSectionLink: (_27 = {
                textDecoration: "none",
                padding: "2rem",
                borderRadius: "5px",
                margin: "0",
                justifyContent: "flex-start",
                transition: "all 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
                boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.15)",
                backgroundColor: "transparent"
            },
            _27[MAX_M] = {
                width: "300px",
                height: "300px",
                margin: "0 auto"
            },
            _27),
        siteSectionContainer: (_28 = {
                marginTop: "0",
                justifyContent: "center",
                display: "grid",
                gridAutoRows: "minmax(300px, max-content)",
                gridGap: "1rem",
                maxWidth: "900px",
                margin: "0 auto"
            },
            _28[MIN_M] = {
                gridTemplateColumns: "repeat(3, 1fr)",
            },
            _28[MAX_M] = {
                gridTemplateColumns: "repeat(2, 1fr)",
            },
            _28[MAX_S] = {
                gridTemplateColumns: "repeat(1, 1fr)",
            },
            _28),
        siteSectionIcon: (_29 = {
                height: "70px",
                width: "auto",
                display: "flex",
                alignSelf: "center",
                justifySelf: "center",
                marginBottom: "1rem",
                "&> img": {
                    height: "100%",
                }
            },
            _29[MIN_S] = {
                height: "70px"
            },
            _29[MAX_S] = {
                marginTop: "1rem",
            },
            _29[MAX_XS] = {
                marginTop: "0.5rem",
                width: "30px",
                height: "30px"
            },
            _29),
        siteSectionTilesLinksItem: (_30 = {
                textDecoration: "none",
                padding: "2rem",
                borderRadius: "5px",
                margin: "0",
                justifyContent: "flex-start",
                transition: "all 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
                boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.15)",
                backgroundColor: "transparent"
            },
            _30[MAX_M] = {
                width: "300px",
                height: "300px",
                margin: "0 auto"
            },
            _30),
        toc: {
            paddingRight: "1rem"
        },
        footerLinkHeaderImage: (_31 = {
                height: "5rem",
                width: "auto",
                margin: '1rem 0'
            },
            _31[MAX_S] = {
                height: "5rem",
                width: "auto",
            },
            _31),
        searchBoxInput: {
            color: "#4C4C4C"
        },
        searchResultsListCount: (_32 = {},
            _32[MIN_M] = {
                paddingTop: "0",
            },
            _32),
        searchResultBreadcrumbs: {
            marginBottom: "1rem"
        },
        searchResultItemHref: {
            marginBottom: "0.25rem",
        },
        searchIndexFiltersButton: {
            backgroundColor: "#2792F3",
        },
        searchIndexApplyFiltersButton: {
            backgroundColor: "#2792F3",
        },
    });
};
exports.default = whitelabelTheme;
//# sourceMappingURL=index.js.map